import React, { useEffect, useState } from "react";
import { getColor, getTextColor } from "../../../utiles/helpers";
import checkNetworkStatus from "../../common/networkStatus/CheckNetworkStatus";
import useErrorHandle from "../../../constant/errorHandling/useErrorHandle";
import { storesCount, storeSummary } from "../../../services/apiServices";
import CurrencyConverter from "@heartinz/currency_subunit_converter";

function StoreProfileData({ isStore }) {
  const [storeCount, setStoreCount] = useState(0);
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const handleError = useErrorHandle();
  const [summary, setSummary] = useState(null);

  const fetchStoreCount = async () => {
    checkNetworkStatus();
    try {
      const storeData = await storesCount({ mainstoreid: isStore?._id });
      setStoreCount(storeData.results.storeCount);
    } catch (error) {
      console.log("e", error);
      handleError(error);
    }
  };

  const fetchStoreSummary = async () => {
    checkNetworkStatus();
    try {
      const storeData = await storeSummary({ mainstoreid: isStore?._id });
      setSummary(storeData.results);
    } catch (error) {
      handleError(error);
    }
  };

  useEffect(() => {
    if (isStore?._id) fetchStoreCount();
    fetchStoreSummary();
  }, [isStore]);

  const totalSummaryData = [
    {
      name: "Today Sale",
      description: "Total sales today",
      icon: "bx bx-trending-up",
      budget: `₹${CurrencyConverter.toCurrency(summary?.totalSaleAmount || 0, "INR")}`,
      color: "text-primary",
      bgColor:"bg-light-blue",
        fontSize:"font-20",
    },
    {
      name: "Box Cash",
      description: "Current cash",
      icon: "bx bx-money",
      budget: `₹${CurrencyConverter.toCurrency(summary?.boxCashBalance || 0, "INR")}`,
      color: "text-pink",
      bgColor:"bg-label-expense",
        fontSize:"font-20",
    },
    {
      name: "Expense",
      description: "Total expenses",
      icon: "bx bx-receipt",
      budget: `₹${CurrencyConverter.toCurrency(summary?.totalExpenseAmount || 0, "INR")}`,
      color: "text-brown",
      bgColor:"bg-light-brown",
        fontSize:"font-20",
    },
    {
      name: "PayLater",
      description: "Total dues",
      icon: "bx bx-credit-card-front",
      budget: `₹${CurrencyConverter.toCurrency(summary?.payLaterTotal[0]?.totalPaylaterBalance || 0, "INR")}`,
      color: "text-paylater",
      bgColor:'bg-light-paylater',
        fontSize:"font-20",
    },
    {
      name: "PayLater Customer",
      description: "Total customer with due",
      icon: "bx bx-group",
      budget: summary?.payLaterTotal[0]?.paylaterCustomers || 0,
       color: "text-warning",
      bgColor:'bg-label-warning',
        fontSize:"font-20",

    },
    {
      name: "Total Customer",
      description: "Registered users",
      icon: "bx bx-group",
      budget: summary?.customerCount || 0,
      color: "text-warning",
      bgColor:'bg-label-warning',
        fontSize:"font-20",
    },
    {
      name: "Product",
      description: "Total items",
      icon: " bx bx-box",
      budget: summary?.productCount || 0,
      color: "text-info",
      bgColor:"bg-light-blue",
        fontSize:"font-20",
    },
  ];

  return (
    <div className="container-fluid py-3 pt-0">
      <div className="row g-4">
        <div className="col-lg-4 mt-0">
          <div className="card h-100 shadow-sm border-0 rounded-3">
            <div className="card-body text-center p-4">
              <div
                className={`avatar avatar-xl mx-auto mb-3 rounded-circle d-flex align-items-center justify-content-center ${getColor(isStore?.stype?.toLowerCase())} bg-opacity-10`}
                style={{ width: "80px", height: "80px" }}
              >
                <i
                  className={`bx bx-store fs-1 ${getTextColor(isStore?.stype)}`}
                ></i>
              </div>
              <h5 className={`fw-bold mb-1 ${getTextColor(isStore?.stype)}`}>
                {isStore?.title || "Store Name"}
              </h5>
              <span
                className={`badge rounded-pill mb-3 ${getColor(isStore?.stype?.toLowerCase())}`}
              >
                {isStore?.stype || "N/A"}
              </span>

              <div className="text-start mt-4">
                <div className="d-flex align-items-center mb-3">
                  <i className="bx bx-phone text-muted me-3 fs-4"></i>
                  <div>
                    <small className="text-muted d-block">Phone </small>
                    <span className="fw-medium">+91 {isStore?.phone || "-"}</span>
                  </div>
                </div>
                <div className="d-flex align-items-center mb-3">
                  <i className="bx bx-envelope text-muted me-3 fs-4"></i>
                  <div>
                    <small className="text-muted d-block">Email </small>
                    <span className="fw-medium">{isStore?.email || "-"}</span>
                  </div>
                </div>
                <div
                  className={`border rounded-3 p-2 mt-3 d-flex flex-column gap-2 border-primary bg-light}`}
                >
                  <div className="d-flex align-items-center gap-2">
                    <p className="mb-0 text-primary ">Total Store Count:</p>
                    <div className="rounded-circle bg-white border border-primary text-primary fw-bold d-flex align-items-center justify-content-center store-count-circle">
                      {storeCount}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="col-lg-8 mt-0">
          <div className="card h-100 shadow-sm border-0 rounded-3">
            <div className="card-header bg-transparent border-bottom p-3">
              <h6 className="mb-0 fw-bold text-primary">Store Summary</h6>
            </div>
            <div className="card-body p-0">
              <ul className="list-group list-group-flush ">
                {totalSummaryData.map((data, index, icon) => (
                  <ProjectItem
                    key={index}
                    {...data}
                    index={index}
                    hoveredIndex={hoveredIndex}
                    setHoveredIndex={setHoveredIndex}
                    isLast={index === totalSummaryData.length - 1}
                  />
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

const ProjectItem = ({
  name,
  description,
  budget,
  bgColor,
  index,
  hoveredIndex,
  setHoveredIndex,
  isLast,
  fontSize,
  icon,
  color 

}) => {
    const budgetString = String(budget);
  const numericBudget = parseFloat(budgetString.replace(/[^0-9.-]+/g, ""));  
  const isNegative = !isNaN(numericBudget) && numericBudget < 0;

   let badgeClass = "bg-label-primary";
  if (isNegative) {
    badgeClass = "bg-label-danger";
  } else if (name === "Box Cash") {
    badgeClass = "bg-label-success";
  }
   let formattedBudget = budget;
  if (isNegative) {
    const absoluteBudget = Math.abs(numericBudget);   
    formattedBudget = `-₹${absoluteBudget}`;
  }
   const handleMouseEnter = () => {
    setHoveredIndex(index); 
  };

  const handleMouseLeave = () => {
    setHoveredIndex(null);
  };
  const listItemClass = `d-flex  align-items-center cursor-poInter p-2   ${index === hoveredIndex ? `${bgColor} highlighted-store ` : ''}`;
  return (
      <li className={`${listItemClass} ${!isLast ? "border-bottom" : ""} `}  onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}>       
        <div class="avatar avatar-md flex-shrink-0 me-4 ">
          <div class={`avatar-initial ${bgColor} rounded-3`}>
            <div>
              <i className={`${icon} ${color} ${fontSize} `}></i>
            </div>
          </div>
        </div>
        <div className="d-flex w-100 flex-wrap align-items-center justify-content-between gap-2">
          <div className="me-2">
            <h6 className="mb-0 fs-14 bold">{name}</h6>
            <small className="font-13">{description}</small>
          </div>
          <div className={`badge rounded-pill ${badgeClass}`}>{formattedBudget}</div>
        </div>
  
      </li>
    // <li
    //   className={`list-group-item d-flex align-items-center justify-content-between p-2 border-0 ${!isLast ? "border-bottom" : ""} ${hoveredIndex === index ? "bg-light" : ""}`}
    //   onMouseEnter={() => setHoveredIndex(index)}
    //   onMouseLeave={() => setHoveredIndex(null)}
    //   style={{ transition: "0.2s" }}
    // >
    //   <div className="d-flex align-items-center">
    //     <div
    //       className={`avatar flex-shrink-0 me-3 rounded-3 ${badgeClass} bg-opacity-10 d-flex align-items-center justify-content-center`}
    //       style={{ width: "42px", height: "42px" }}
    //     >
    //       <i className={`${icon} fs-4 ${iconColorClass}`}></i>
    //     </div>
    //     <div>
    //       <h6 className="mb-0 fw-semibold fs-14">{name}</h6>
    //       <small className="text-muted">{description}</small>
    //     </div>
    //   </div>
    //   <div
    //     className={`badge ${badgeClass} rounded-3 d-flex align-items-center justify-content-center fw-bold`}
    //     style={{ minWidth: "65px", padding: "10px 12px", fontSize: "0.9rem" }}
    //   >
    //     {budget}
    //   </div>
    // </li>
  );
};

export default StoreProfileData;
